import { get } from 'lodash';
import { combineReducers } from 'redux';

import { DEFAULT_ACTION } from '../../constants';
import * as actionTypes from './actionTypes';

const initialState = {
    isLoading: false,
    countries: []
};

export const isLoading = (state = initialState.isLoading, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_COUNTRIES_SUCCESS:
        case actionTypes.GET_COUNTRIES_FAIL:
            return false;
        case actionTypes.GET_COUNTRIES_START:
            return true;
        case actionTypes.RESET:
            return initialState.isLoading;
        default:
            return state;
    }
};

export const countries = (state = initialState.countries, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_COUNTRIES_SUCCESS:
            return action.payload;
        case actionTypes.RESET:
            return initialState.countries;
        default:
            return state;
    }
};

export const getIsLoading = state => get(state, 'isLoading', initialState.isLoading);

export const getCountries = state => get(state, 'countries', initialState.countries);

const reducer = combineReducers({
    isLoading,
    countries
});

export default reducer;
